export const GENERAL = 'general';
export const NOTIFICATIONS = 'notifications';
export const TABLE_IMAGE = 'PieceTableImageClickBehavior';

export const PREVIEW = 'preview';
export const DETAILS = 'details';

export const PREFERRED_TIME_ZONE = 'PreferredTimeZone';
export const LOCAL_TIME_ZONE = '';
export const MAILROOM_TIME_ZONE = 'mailroom';
